import React, { useEffect } from "react";
import styled from "styled-components";

export const Title = styled.h2`
  font-size: 20px;
  color: #fff;
  font-weight: 700;
  line-height: 120%;
  font-family: "Balsamiq Sans", cursive;
`;

export const Network = {
  ETHEREUM: 1,
  BSC: 56,
  // ETHEREUM: 3, // test net
  // BSC: 97, // test net
};

export const WrongNetwork = styled.div`
  margin-top: 20px;
  border: 1px solid #fff;
  padding: 30px;
  border-radius: 5px;
  background-color: #b93965;

  p {
    font-size: 16px;
    line-height: 20px;
    font-family: "Balsamiq Sans", cursive;
    color: #ffa2c2;
    margin: 0;
  }

  strong {
    text-decoration: underline;
  }
`;

export const ETH_FEES_AMOUNT = 0.1; // 0.25;
export const BNB_FEES_AMOUNT = 1; // 0.75

export const ETH_FEES_AMOUNT_WEI = 100000000000000000; //250000000000000000;
export const BNB_FEES_AMOUNT_WEI = 1000000000000000000; //750000000000000000;

// export const ETH_FEES_AMOUNT = 0.01;
// export const BNB_FEES_AMOUNT = 0.001;
// export const ETH_FEES_AMOUNT_WEI = 1000000000000000;
// export const BNB_FEES_AMOUNT_WEI = 10000000000000000;

export const ETH_URL = "https://etherscan.io/";
export const BSC_URL = "https://bscscan.com/";
export const PAYMENT_ADDRESS = "0xc38097966c45ed50e85baff6e9065Bd01561Eb2E";

// https://bscscan.com/unitconverter - WEI converter

// export const ETH_URL = 'https://ropsten.etherscan.io/';
// export const BSC_URL = 'https://testnet.bscscan.com/';
